/**
 * Telemetría funnel plan Crece.
 * Implementación web en apps/vuelto-negocio; este módulo solo nombra eventos.
 */
export type CreceFunnelEvent =
  | 'crece_cta_click'
  | 'crece_auth_view'
  | 'crece_activar_view'
  | 'crece_pay_redirect'
  | 'crece_pay_return'
  | 'crece_active'
  | 'crece_soft_limit_view'
  | 'crece_soft_limit_dismiss';

export const CRECE_FUNNEL_EVENTS = {
  ctaClick: 'crece_cta_click',
  authView: 'crece_auth_view',
  activarView: 'crece_activar_view',
  payRedirect: 'crece_pay_redirect',
  payReturn: 'crece_pay_return',
  creceActive: 'crece_active',
  softLimitView: 'crece_soft_limit_view',
  softLimitDismiss: 'crece_soft_limit_dismiss',
} as const satisfies Record<string, CreceFunnelEvent>;
